import { Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import {
	DatatableComponent,
	ColumnMode,
	SelectionType,
} from "@swimlane/ngx-datatable";
import { ClienteService } from "@core/services/cliente.service";
import Swal from "sweetalert2";

import { Subject } from "rxjs";
import { AuthenticationService } from "app/auth/service";
import { Router } from "@angular/router";
import { ClienteContatoService } from "@core/services/cliente-contato.service";

@Component({
	selector: "app-cliente",
	templateUrl: "./listar-cliente.component.html",
	styleUrls: ["./listar-cliente.component.scss"],
	providers: [ClienteService],
	encapsulation: ViewEncapsulation.None,
})
export class ListarClienteComponent implements OnInit {
	// Private
	private _unsubscribeAll: Subject<any>;
	private tempData = [];

	// public
	public contentHeader: object;
	public selected = [];
	public basicSelectedOption: number = 10;
	public ColumnMode = ColumnMode;
	public contatoDel = [];
	public starting: boolean = false;

	rows = [];
	title = "angular-datatables";
	temp = [];
	customPatterns = { "0": { pattern: new RegExp("\\d") } };
	// -1 = Todos. Nao usar 0 como sentinela aqui: 0 e um status real de cliente (Inativo).
	selectedStatus: any = -1;

	constructor(
		private clienteService: ClienteService,
		private clienteContatoService: ClienteContatoService
	) {
		this._unsubscribeAll = new Subject();
	}

	@ViewChild(DatatableComponent) table: DatatableComponent;
	@ViewChild("tableRowDetails") tableRowDetails: any;
	ngOnInit(): void {
		this.starting = true;

		this.clienteService.get().subscribe(
			(res) => {
				(this.rows = res), (this.temp = res);
				this.starting = false;
			},
			(error) => {
				console.log(error);
				this.starting = false;
			}
		);

		this.contentHeader = {
			headerTitle: "Clientes",
			actionButton: false,
			breadcrumb: {
				type: "",
				links: [
					{
						name: "Início",
						isLink: false,
					},
					{
						name: "Cliente",
						isLink: false,
					},
				],
			},
		};
	}

	ngAfterContentChecked() {
		this.rows = [...this.rows];
	}

	public msgConfirmacao(data) {
		Swal.fire({
			title: "Confirmação",
			text: "Deseja mesmo excluir?",
			icon: "warning",
			showCancelButton: true,
			confirmButtonText: "Excluir",
			cancelButtonText: "Cancelar",
			customClass: {
				confirmButton: "btn btn-danger",
				cancelButton: "btn btn-primary ml-1",
			},
		}).then((result) => {
			if (result.isConfirmed) {
				this.clienteDelete(data);
			}
		});
	}
	
	formatarNome(nome: string): string {
		return nome.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
	}

	public clienteDelete(id: number) {
		return this.clienteService.delete(id).subscribe(
			(res) => {
				if (res) {
					this.clienteContatoService.getIdCliente(id).subscribe(
						(res) => {
							for (let index = 0; index < res.length; index++) {
								this.clienteContatoService.delete(res[index].id).subscribe();
							}
						},
						(error) => error
					);
				}
				Swal.fire({
					title: "Sucesso!",
					text: "O item foi excluído.",
					icon: "success",
					confirmButtonText: "Confirmar",
				}).then((result) => {
					if (result.isConfirmed) {
						this.clienteService.get().subscribe(
							(res) => (this.rows = res),
							(error) => error
						);
					}
				});
			},
			(error) => {
				Swal.fire("Erro!", "Ocorreu um erro ao cadastrar.", "error");
			}
		);
	}

	nomeContratanteFilter(event) {
		const val = event.target.value.toLowerCase();

		// filter our data
		const temp = this.temp.filter(function (d) {
			if (d.nome_contratante != null) {
				return d.nome_contratante.toLowerCase().indexOf(val) !== -1 || !val;
			}
		});

		// update the rows
		this.rows = temp;
		// Whenever the filter changes, always go back to the first page
		this.table.offset = 0;
	}

	razaoSocialFilter(event) {
		const val = event.target.value.toLowerCase();

		// filter our data
		const temp = this.temp.filter(function (d) {
			if (d.razao_social != null) {
				return d.razao_social.toLowerCase().indexOf(val) !== -1 || !val;
			}
		});

		// update the rows
		this.rows = temp;
		// Whenever the filter changes, always go back to the first page
		this.table.offset = 0;
	}

	nomeFantasiaFilter(event) {
		if (event.target.value != null) {
			const val = event.target.value.toLowerCase();

			// filter our data
			const temp = this.temp.filter(function (d) {
				if (d.nome_fantasia) {
					if (d.nome_fantasia != null) return d.nome_fantasia.toLowerCase().indexOf(val) !== -1 || !val;
				} else {
					return !val
				}
			});

			// update the rows
			this.rows = temp;
			// Whenever the filter changes, always go back to the first page
			this.table.offset = 0;
		}
	}

	cnpjFilter(event) {
		const val = event.target.value.toLowerCase();

		// filter our data
		const temp = this.temp.filter(function (d) {
			if (d.cpf_cnpj_cliente != null) return d.cpf_cnpj_cliente.toLowerCase().indexOf(val) !== -1 || !val;
		});

		// update the rows
		this.rows = temp;
		// Whenever the filter changes, always go back to the first page
		this.table.offset = 0;
	}

	cidadeFilter(event) {
		const val = event.target.value.toLowerCase();

		// filter our data
		const temp = this.temp.filter(function (d) {
			if (d.cidade != null) return d.cidade.toLowerCase().indexOf(val) !== -1 || !val;
		});

		// update the rows
		this.rows = temp;
		// Whenever the filter changes, always go back to the first page
		this.table.offset = 0;
	}

	estadoFilter(event) {
		const val = event.target.value.toLowerCase();

		// filter our data
		const temp = this.temp.filter(function (d) {
			if (d.estado != null) return d.estado.toLowerCase().indexOf(val) !== -1 || !val;
		});

		// update the rows
		this.rows = temp;
		// Whenever the filter changes, always go back to the first page
		this.table.offset = 0;
	}

	// Filtro por status do cliente (0 = Inativo, 1 = Ativo, 3 = Cancelado, 4 = Bloqueado).
	// Comparacao exata (nao substring): ids de um digito colidiriam entre si em indexOf.
	statusFilter() {
		if (this.selectedStatus == -1) {
			this.rows = this.temp;
			this.table.offset = 0;
			return;
		}
		const val = String(this.selectedStatus);
		this.rows = this.temp.filter((d) => String(d.id_status) === val);
		this.table.offset = 0;
	}

	testeFilter(event) {
		const val = event.target.value.toLowerCase();
	
		const temp = this.temp.filter((d) => {

			let flgTeste = '';
			if (d.flg_teste === 1) {
				flgTeste = 'sim';
			} else if (d.flg_teste === 0) {
				flgTeste = 'não';
			}
	
			return flgTeste.indexOf(val) !== -1 || !val;
		});
	
		this.rows = temp;
	
		this.table.offset = 0;
	}
	
	
}
